import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import CsvDownload from 'react-json-to-csv'
import Loader from "react-loader-spinner";


class ConfiguracaoAdmin extends Component {



  constructor(props) {
    super(props);

    this.state ={
        downloadsmatricula:null,
      btnname:"Aguarde",
      btn:true
    }
   
  }

  

  async componentDidMount(){
    const response = await api.get("/downloadsmatricula");
    this.setState({ downloadsmatricula: response.data
     });

     if(this.state.downloadsmatricula){
       this.setState({
         btnname:"Download do relatório",
         btn:false
       })
     }

  }





  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <center><h4>Relatório de Matriculas</h4> </center>
        <Loader
          className="d-flex justify-content-center"
          type="TailSpin"
          color="#00BFFF"
          height={100}
          width={100}
          visible={this.state.btn==true} //3 secs
          />
        {this.state.btn==false &&
          <CsvDownload children="Extrair Relatório" class="btn btn-dark  " disabled={this.state.btn==true} filename={"inscritos_olgamettig"+new Date().getDate()+'-'+new Date().getMonth()+'-'+new Date().getFullYear()+".csv"} data={this.state.downloadsmatricula} />
        }



    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(ConfiguracaoAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/downloaduserdata.js